import { render } from "./HowToPlayView.vue?vue&type=template&id=e8e244e8&scoped=true"
import script from "./HowToPlayView.vue?vue&type=script&lang=js"
export * from "./HowToPlayView.vue?vue&type=script&lang=js"

import "./HowToPlayView.vue?vue&type=style&index=0&id=e8e244e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e244e8"]])

export default __exports__